import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MapPin, Navigation } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function Experiences() {
  const [items, setItems] = useState([]);
  const [cats, setCats] = useState([]);
  const [active, setActive] = useState("All");

  useEffect(() => {
    api.get(`/experiences?category=${encodeURIComponent(active)}`).then((r) => {
      setItems(r.data.experiences); setCats(["All", ...r.data.categories]);
    });
  }, [active]);

  return (
    <div className="mx-auto max-w-7xl px-5 py-12 lg:px-8">
      <span className="overline">Experiences</span>
      <h1 className="mt-2 text-4xl lg:text-5xl">Curated things to do</h1>
      <p className="mt-3 max-w-xl text-taupe">Restaurants, wineries, tubing, golf and more — handpicked near your stay and bookable through your concierge.</p>

      <div className="mt-8 flex flex-wrap gap-2">
        {cats.map((c) => (
          <button key={c} data-testid={`exp-cat-${c}`} onClick={() => setActive(c)}
            className={`rounded-full border px-4 py-2 text-sm transition-colors ${active === c ? "border-ink bg-ink text-white" : "border-black/10 text-ink hover:border-camel"}`}>
            {c}
          </button>
        ))}
      </div>

      <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((e, i) => (
          <div key={e.id} className="overflow-hidden rounded-3xl card-lux lift animate-fade-up" style={{ animationDelay: `${i * 50}ms` }}>
            <div className="relative aspect-[3/2] overflow-hidden">
              <img src={e.image} alt={e.name} className="h-full w-full object-cover" />
              <span className="absolute left-4 top-4 rounded-full glass px-3 py-1 text-xs font-semibold">{e.category}</span>
            </div>
            <div className="p-5">
              <h3 className="text-xl text-ink">{e.name}</h3>
              <p className="mt-1 text-sm text-taupe">{e.blurb}</p>
              <div className="mt-3 flex items-center gap-1 text-xs text-taupe"><MapPin size={13} /> {e.distance}</div>
              <div className="mt-4 flex gap-2">
                <Button data-testid={`exp-book-${e.id}`} onClick={() => toast.success(`${e.name} — request sent to your concierge`)} className="flex-1 rounded-full btn-ink">Book Experience</Button>
                <a href={`https://www.openstreetmap.org/?mlat=${e.lat}&mlon=${e.lng}#map=14/${e.lat}/${e.lng}`} target="_blank" rel="noreferrer">
                  <Button variant="outline" size="icon" className="rounded-full border-black/10"><Navigation size={16} /></Button>
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
